import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import type { TinyMCEData } from '@/types/editor'
import { escapeHtml } from '@messenger/utils'

type MemorialContributionsTemplateProps = {
  editorProps: TinyMCEData
  firstInsertion?: boolean
}

export const memorialContributionsTemplate = (
  templateProps: MemorialContributionsTemplateProps,
) => {
  const { editorProps, firstInsertion } = templateProps
  const { caseDetails, selectedTheme } = editorProps
  const { memorial_contributions } = caseDetails || {}

  let content = ''

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme: selectedTheme ?? null,
    editor: editorProps.editor,
    firstInsertion,
  })

  memorial_contributions?.forEach((memorialData, i) => {
    const memorial = `${i + 1}. ${escapeHtml(String(memorialData.name ?? ''))}`

    if (memorial) {
      content += `<p><span>${memorial}</span></p><br/>`
    }
  })

  const html = `&#8202;<div data-template="memorial_contributions" class="mceNonEditable" style="${themeStyles}">${content}</div>&#8202;`

  return html
}

export default memorialContributionsTemplate
